import { ChartBinSize, ChartDefinition, ChartKey, ChartRendererType } from '@frontend/chart/types';

import { TRANSACTION_VOLUME_CHART_ENDPOINT } from '../transaction-chart-endpoints';

export const TRANSACTION_VOLUME_BY_CUSTOMER_BAR_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.TRANSACTION_VOLUME_BY_CUSTOMER_BAR,
    chartType: ChartRendererType.BAR,
    endpoint: TRANSACTION_VOLUME_CHART_ENDPOINT,
    filters: [{ key: 'bin_size', value: ChartBinSize.FULL_PERIOD }],
    groupBy: 'account_id'
};
